import { isValid, parse as parseDateFns } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Parses a user-typed French date string, tolerating a separator-less entry
 * (e.g. "01082026" → 01/08/2026, "010826" → 01/08/2026) as the previous
 * Moment adapter did. Returns a plain browser-local Date (date-only), or null.
 *
 * date-fns' parse is strict about the literal "/" separators, so a direct parse
 * of "01082026" against "dd/MM/yyyy" fails; the fallback strips the input to its
 * digits and re-inserts the slashes when it holds a full date (8 digits → yyyy,
 * 6 digits → yy). Any other digit count is rejected to avoid date-fns matching a
 * truncated year (e.g. "0108202" → year 0202).
 */
export function parseFrenchDate(value: string, format: string): Date | null {
  const referenceDate = new Date();

  const direct = parseDateFns(value, format, referenceDate, { locale: fr });
  if (isValid(direct)) {
    return direct;
  }

  const digits = value.replace(/\D/g, '');
  if (digits.length === 8 || digits.length === 6) {
    const yearFormat = digits.length === 8 ? 'yyyy' : 'yy';
    const slashed = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    const parsed = parseDateFns(slashed, `dd/MM/${yearFormat}`, referenceDate, { locale: fr });
    if (isValid(parsed)) {
      return parsed;
    }
  }

  return null;
}
